import { v4 as uuidv4 } from 'uuid';

import { OtherLocalStorageKey } from ':shared/enums';

export const createUserIdentity = (): void => {
    const isJwtTokenInLocalStorage = !!localStorage.getItem(OtherLocalStorageKey.JWT_TOKEN);
    if (!isUserIdentityInLocalStorage()) {
        setUserIdentityInLocalStorage(isJwtTokenInLocalStorage ? `malou-${uuidv4()}` : uuidv4());
    } else if (isJwtTokenInLocalStorage && !isMalouUserIdentityInLocalStorage()) {
        const userIdentity = getUserIdentityFromLocalStorage();
        localStorage.setItem(OtherLocalStorageKey.USER_IDENTITY, `malou-${userIdentity}`);
    }
};

export const setUserIdentityInLocalStorage = (userIdentity: string): void =>
    localStorage.setItem(OtherLocalStorageKey.USER_IDENTITY, userIdentity);

export const getUserIdentityFromLocalStorage = (): string | null => localStorage.getItem(OtherLocalStorageKey.USER_IDENTITY);

export const isUserIdentityInLocalStorage = (): boolean => !!getUserIdentityFromLocalStorage();

export const isMalouUserIdentityInLocalStorage = (): boolean => {
    const userIdentity = getUserIdentityFromLocalStorage();
    return !!userIdentity && userIdentity.startsWith('malou-');
};

export const removeUserIdentityInLocalStorage = (): void => localStorage.removeItem(OtherLocalStorageKey.USER_IDENTITY);
